export default [
    {
        path: '',
        name: 'homerouter',
        component: () => import('./page-home')
    }
]